export default "/profile/images/another-payment-system.png?5af00324693f0fb9e8a4c92714891506";